import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { AccountType } from 'dashboard/models/account-type';
import { AccountTypeGridLayout } from 'dashboard/models/account-type-grid-layouts';
import { AccountVariableDefinition } from 'dashboard/models/account-variable-definition';
import {
  setAccountType,
  setAccountTypeGridLayouts,
  setAccountVariableDefinitions,
  updateDefaultStatus,
} from 'dashboard/redux/slices/account-type';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadAccountType(id: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.getResource<AccountType>(
      ApiEndpoint.AccountType,
      id,
    );

    const accountTypeGridLayouts =
      response.included?.filter(
        (relationship) => relationship.type === ApiModel.AccountTypeGridLayout,
      ) ?? [];

    const accountVariableDefinitions =
      response.included?.filter(
        (relationship) => relationship.type === ApiModel.AccountVariableDefinition,
      ) ?? [];

    dispatch(setAccountTypeGridLayouts(accountTypeGridLayouts as AccountTypeGridLayout[]));
    dispatch(
      setAccountVariableDefinitions(accountVariableDefinitions as AccountVariableDefinition[]),
    );
    dispatch(setAccountType(response.data));
  };
}

export const setDefaultAccountTypeStatus =
  (accountTypeId: string, accountStatusId: string): DashboardThunkAction<Promise<void>> =>
  async (dispatch) => {
    const response = await SessionClientDashboard.updateResource<AccountType>(
      {
        type: ApiModel.AccountType,
        id: accountTypeId,
      },
      { meta: { 'default-account-status-id': accountStatusId } },
    );

    dispatch(updateDefaultStatus(response.data));
  };
